module.exports = __webpack_public_path__ + "img/save-money.69e3a28d.png";